import React, { useRef } from 'react';

import { defaultTo } from 'ramda';
import styled from 'styled-components/native';
import { useHover } from 'react-native-web-hooks';

import { useClickOutside } from '../../spices';
import {
  FOHSpaceSmall,
  FOHToolTip,
  FOHToolTipType,
  FOHColors,
  FullWidthCard,
  FOHVerticalDivider,
  FOHDropDownArrow,
  FOHView,
  FOHTouchableOpacity,
  ButtonText
} from '../../ingredients';

export interface FOHCompoundDropdownButtonProps {
  title: string;
  testID?: string;
  open?: boolean;
  onPress?: () => void;
  toggleOpen: () => void;
  children: React.ReactNode;
  style?: any;
  menuTop?: number;
  disabled?: boolean;
  secondaryColor?: string;
  icon?: any;
  textColor?: string;
  cardStyle?: any;
  isToolTip?: boolean;
  tipHelper?: string;
}

export const FOHCompoundDropdownButton = (
  props: FOHCompoundDropdownButtonProps
) => {
  const [ref] = useClickOutside({
    close: () => !!props.open && props.toggleOpen && props.toggleOpen()
  });
  const hoverRef = useRef(null);
  const isHovered = useHover(hoverRef);
  const btnRef = useRef(null);
  const isBtnHover = useHover(btnRef);
  const dropdownRef = useRef(null);
  const isDropdownHover = useHover(dropdownRef);

  return (
    <FOHView ref={ref}>
      <FOHView
        style={{
          width: '100%',
          zIndex: 1
        }}
      >
        {props.disabled && props.isToolTip && (
          <FOHView style={{ position: 'absolute' }}>
            <FOHToolTip
              type={FOHToolTipType.BOTTOM_CENTER}
              helpText={props.tipHelper}
              open={isHovered}
              style={{ width: 250, top: 85 }}
              width={250}
            />
          </FOHView>
        )}
        <FOHButtonContainer
          ref={hoverRef}
          style={{
            backgroundColor: props.disabled
              ? FOHColors.GRAYSCALE_100
              : FOHColors.PRIMARY_TEAL_P1,
            borderRadius: 4,
            width: '100%',
            flexDirection: 'row',
            ...(props.style ? props.style : {})
          }}
        >
          <FOHTouchableOpacity
            ref={btnRef}
            onPress={props.onPress}
            disabled={props.disabled}
            testID={props.testID || 'foh-compound-dropdown-button-main-action'}
            style={{
              flex: 4,
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              paddingHorizontal: 16,
              borderRadius: 4,
              backgroundColor:
                !props.disabled && isBtnHover ? FOHColors.PRIMARY_TEAL_300 : ''
            }}
          >
            {props.icon && (
              <>
                {props.icon}
                <FOHSpaceSmall />
              </>
            )}
            <ButtonText
              style={{
                color: props.disabled
                  ? FOHColors.GRAYSCALE_400
                  : props.textColor
                  ? props.textColor
                  : FOHColors.WHITE
              }}
            >
              {props.title}
            </ButtonText>
          </FOHTouchableOpacity>

          <FOHVerticalDivider
            color={
              props.secondaryColor ? props.secondaryColor : FOHColors.WHITE
            }
          />
          <FOHTouchableOpacity
            ref={dropdownRef}
            onPress={props.toggleOpen}
            disabled={props.disabled}
            testID={
              props.testID
                ? `${props.testID}-open-close`
                : 'foh-compound-dropdown-button-open-close'
            }
            style={{
              paddingHorizontal: 8,
              justifyContent: 'center',
              alignItems: 'center',
              borderBottomRightRadius: 6,
              borderTopRightRadius: 6,
              backgroundColor: props.open
                ? FOHColors.PRIMARY_TEAL_200
                : !props.disabled && isDropdownHover
                ? FOHColors.PRIMARY_TEAL_300
                : '',
              paddingLeft: 4,
              paddingRight: 4,
              width: 41
            }}
          >
            <FOHDropDownArrow
              style={{
                tintColor: props.disabled
                  ? FOHColors.GRAYSCALE_400
                  : props.textColor
                  ? props.textColor
                  : FOHColors.WHITE,
                width: 32,
                height: 32,
                transform: props.open ? [{ rotate: '180deg' }] : []
              }}
            />
          </FOHTouchableOpacity>
        </FOHButtonContainer>
        {props.open && (
          <FullWidthCard
            shadow={true}
            style={{
              paddingVertical: 24,
              position: 'absolute',
              top: props.menuTop || 54,
              width: '100%',
              minWidth: 293,
              zIndex: 10,
              right: 0,
              ...defaultTo({}, props.cardStyle)
            }}
            testID={'FOHCompoundDropdownButton-menu'}
          >
            {props.children}
          </FullWidthCard>
        )}
      </FOHView>
    </FOHView>
  );
};

export const FOHButtonContainer = styled(FOHView)`
  height: 40px;
`;
